import * as tslib_1 from "tslib";
// Core packages
import { OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
// Third party packages
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
// Custom packages
import { AuthService } from 'src/app/modules/auth/auth.service';
import { User } from 'src/app/shared/models/user/user.model';
import { ApiService } from 'src/app/shared/services/api.service';
import { ConfigService } from 'src/app/shared/services/config.service';
var CategoriesDialogComponent = /** @class */ (function () {
    /**
     * Class constructor
     */
    function CategoriesDialogComponent(dialogRef, chooseRecipientsDialog, data, confirmDialog, configService, cookieService, translateService, authService, apiService) {
        this.dialogRef = dialogRef;
        this.chooseRecipientsDialog = chooseRecipientsDialog;
        this.data = data;
        this.confirmDialog = confirmDialog;
        this.configService = configService;
        this.cookieService = cookieService;
        this.translateService = translateService;
        this.authService = authService;
        this.apiService = apiService;
        this.subscriptions = [];
        this.loggedUser = new User();
        this.lang = this.translateService.currentLang || this.translateService.defaultLang;
        // BEGIN - Add subUser form
        // BEGIN - ngx-formly
        this.form = new FormGroup({});
        this.model = {};
        this.fields = [];
        this.options = {};
        // END - ngx-formly
        this.showBcc = false;
        this.formBtnOptions = {
            active: false,
            text: this.translateService.instant('common.cta.send'),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: 'primary',
            spinnerColor: 'primary',
            fullWidth: false,
            disabled: false,
            mode: 'indeterminate',
            buttonIcon: {
                fontSet: 'fal',
                fontIcon: 'fa-paper-plane',
                inline: true,
            },
        };
        this.attachmentBtnOptions = {
            active: false,
            text: this.translateService.instant('common.cta.attach'),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: 'accent',
            spinnerColor: 'accent',
            fullWidth: false,
            disabled: false,
            mode: 'indeterminate',
            buttonIcon: {
                fontSet: 'fal',
                fontIcon: 'fa-paperclip',
                inline: true,
            },
        };
        // END - Add communication form
        this.dialogIsLoading = true;
        this.isAdmin = false;
        this.isMaster = false;
    }
    /**
     * Init component
     *
     */
    CategoriesDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Get logged user data
        this.subscriptions.push(this.authService.loggedUser$.subscribe(function (res) { return _this.loggedUser.setData(res); }));
        if (this.authService.loggedUserRequestedRoleType$.getValue() === "admin"
            || this.authService.loggedUserRequestedRoleType$.getValue() === "operator") {
            this.isAdmin = true;
        }
        if (this.authService.loggedUserRequestedRoleType$.getValue() === "master"
            || this.authService.loggedUserRequestedRoleType$.getValue() === "collaborator") {
            this.isMaster = true;
        }
        // Get current lang
        this.lang = this.cookieService.get('lang') || this.configService.defaultLang;
        this.dialogIsLoading = false;
        // Get form initial values and init the form
        this.initForm();
    };
    /**
     * Handle component destroy
     *
     * @since 1.0.0
     */
    CategoriesDialogComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    /**
     * Init form
     *
     * @since 1.0.0
     */
    CategoriesDialogComponent.prototype.initForm = function () {
        var e_1, _a;
        var categoriesOptions = [];
        var rawCategories = this.translateService.instant('suppliers.categories');
        try {
            for (var _b = tslib_1.__values(Object.keys(rawCategories)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var trans = _c.value;
                categoriesOptions.push({
                    label: rawCategories[trans],
                    value: trans,
                });
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (this.data.model &&
            Array.isArray(this.data.model)) {
            console.log(this.data.model);
            this.model = this.data.model;
        }
        this.fields = [
            {
                fieldGroupClassName: "row",
                fieldGroup: [
                    {
                        className: "col-12",
                        type: 'select',
                        key: 'categories',
                        templateOptions: {
                            label: this.translateService.instant('suppliers.search.fields.categories'),
                            placeholder: this.translateService.instant('suppliers.search.fields.categories'),
                            multiple: true,
                            options: categoriesOptions,
                        },
                    },
                ],
            },
        ];
    };
    /**
     * Handle dialog closing
     *
     * @since 1.0.0
     */
    CategoriesDialogComponent.prototype.onClose = function () {
        this.dialogRef.close();
    };
    /**
     * Handle form submit
     *
     * @since 1.0.0
     */
    CategoriesDialogComponent.prototype.onFormSubmit = function (model) {
        // // Prevent invalid form submit
        // if (this.form.invalid) {
        //   Object.keys(this.form.controls).forEach(key => {
        //     this.form.controls[key].markAsTouched();
        //   });
        //   this.toastrService.error(this.translateService.instant('common.errors.form_is_invalid'));
        //   return;
        // }
        this.dialogRef.close(model.categories);
    };
    return CategoriesDialogComponent;
}());
export { CategoriesDialogComponent };
